import { DocumentsPage, PageHead, SeoFooter } from '@/components'

const Documents = ({ data }) => {
    return (
        <>
            <PageHead meta={data.seo_meta} />
            <DocumentsPage title={data.title} docs={data.docs} />
            {data.seo_meta.addtional_description && <SeoFooter text={data.seo_meta.addtional_description} />}
        </>
    )
}

Documents.getInitialProps = async ({ api }) => {
    const { data } = await api.pageWithSlug('docs')()

    return { data: data }
}

export default Documents
